import * as mdCondition from '../services/mdCondition';

export default {
  namespace: 'mdCondition',

  state: {
    getMdRuleList: null,
    saveMdRuleList: null,
    editOutputList: null,
    deleteOutputList: null,
    getRuleList: null,
    addOutputList: null,
    deleteRuleList: null,
    saveMultipleRuleList: null,
    deleteMulRuleList: null,
  },

  effects: {
    *getMdRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mdCondition.getMdRuleList, values);
      yield put({
        type: 'save',
        payload: {
          getMdRuleList: response,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *saveMdRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mdCondition.saveMdRuleList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveMdRuleList: response,
        },
      });
    },

    *editOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mdCondition.editOutputList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editOutputList: response,
        },
      });
    },
    *addOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mdCondition.addOutputList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addOutputList: response,
        },
      });
    },
    *deleteOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        mdCondition.deleteOutputList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteOutputList: response,
        },
      });
    },
    *getRuleList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(mdCondition.getRuleList, values);
      yield put({
        type: 'save',
        payload: {
          getRuleList: response,
        },
      });
    },
    *saveRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(mdCondition.saveRuleList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveRuleList: response,
        },
      });
    },
    *saveMultipleRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        mdCondition.saveMultipleRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveMultipleRuleList: response,
        },
      });
    },
    *deleteRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleList: response,
        },
      });
    },
    *deleteMulRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteMulRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteMulRuleList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
